import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import User from '@/components/User'
import MaintGrp from '@/components/MaintGrp'
import ContComp from '@/components/ContractorCompany'
import Plant from '@/components/Plants'
import Language from '@/components/Language'
import PlantSpecificData from '@/components/PlantSpecificData'
import Feedback from '@/components/Feedback'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/ContractorHeadCount/home', name: 'Home', component: Home },
    { path: '/ContractorHeadCount/user', name: 'User', component: User },
    { path: '/ContractorHeadCount/maintainenceGroup', name: 'MaintGrp', component: MaintGrp },
    { path: '/ContractorHeadCount/contractorcompany', name: 'ContComp', component: ContComp },
    { path: '/ContractorHeadCount/plants', name: 'Plant', component: Plant },
    { path: '/ContractorHeadCount/languages', name: 'Language', component: Language },
    { path: '/ContractorHeadCount/plantspecificdata', name: 'PlantSpecificData', component: PlantSpecificData },
    { path: '/ContractorHeadCount/feedback', name: 'Feedback', component: Feedback }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js